import { CoreLink } from '@uncinc/react-drupal-core';
import React from 'react';
import classnames from 'classnames';

import './style.scss';

const ExternalPublication = (props) => {
  const { title, link, year, authors, className } = props;

  return (
    <div className={classnames(className, 'ExternalPublication')}>
      <div className="ExternalPublication__icon"><i className="icon icon-book" /></div>
      <strong className="ExternalPublication__year">{year}</strong>
      <div className="ExternalPublication__title">

        <span className="ExternalPublication__title__link">
          {link && (
            <CoreLink to={link}>
              <span>{title}</span>
              <i className="icon icon-arrow-right" />
            </CoreLink>
          )}
          {!link && (
            <span>{link}</span>
          )}
        </span>
      </div>
      <span className="ExternalPublication__authors">{authors}</span>
    </div>
  );
};

export default ExternalPublication;
